const switcher = document.querySelectorAll('[data-set-gender]');
const is_men_tpl = document.querySelector('body').classList.contains('template-men');
const is_women_tpl = document.querySelector('body').classList.contains('template-women');
const menus = document.querySelectorAll('[data-gender-menu]');

// Check template and store gender
if(is_women_tpl){
    localStorage.setItem("gender", 'women');
}
if(is_men_tpl){
    localStorage.setItem("gender", 'men');
}

// Get stored gender
window.gender = localStorage.getItem("gender");

if(window.gender){
    let logourl = document.querySelector('.Header .gender-switch [data-set-gender="'+window.gender+'"]').getAttribute('href');
    document.querySelector('.Header__LogoLink').setAttribute('href', logourl);

    menus.forEach(menu => {
        if(menu.getAttribute('data-gender-menu') == window.gender){
            menu.classList.add('show');
        } else {
            menu.classList.remove('show');
        }
    });

    // On gender change
    switcher.forEach(item => {
        if(item.getAttribute('data-set-gender') == window.gender){
            item.classList.add('is-active');
            item.parentNode.classList.add('is-active');
        } 

        item.addEventListener('click', e => {
            e.preventDefault();

            let gender = item.getAttribute('data-set-gender'),
                redirect = item.getAttribute('href');

            localStorage.setItem("gender", gender);
            window.gender = gender;

            window.location.href = redirect;
        });
    });
} else {
    menus.forEach(menu => {
        if(menu.getAttribute('data-gender-menu') == 'unisex'){
            menu.classList.add('show');
        }
    });
}

//Announcement bar
const announcement_man = document.querySelector('.announcement_man');
const announcement_woman = document.querySelector('.announcement_woman');

if(window.gender == 'men') {
  if(announcement_woman) {announcement_woman.style.display = 'none'}
} else {
  if(announcement_man) {announcement_man.style.display = 'none'}
}

console.log('Stored gender: ' + window.gender);